
































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import axios from 'axios'
import { Toast } from 'vant'
import rtSelect from '@/components/estate/selectCom.vue'
const estateModule = namespace('estate')

@Component({
  components: { rtSelect }
})
export default class Assign extends Vue {
  @estateModule.State('estateAssginList') estateAssginList!: any
  searchTime: any = ''
  repairPersonnelList: any = []
  repairPersonId: any = ''
  repairPerson: string = ''
  mounted() {
    this.searchTime = this.$route.query.time
    this.getEstateAssignList()
  }
  async getEstateAssignList() {
    const { error, success } = await this.$store.dispatch(
      'estate/estateAccountAssignList',
      {
        functionResource: '/estateWorker'
      }
    )
  }
  handleSelectPersonClick(val: any) {
    this.repairPersonId = val.accountId
    this.repairPerson = val.name
  }
  handleCreateClick() {
    if (this.repairPersonId == '' || !this.repairPersonId) {
      Toast('请选择维修人员')
      return
    }
    this.estateMaintainTransfer()
  }
  /**转派-维修工端 */
  async estateMaintainTransfer() {
    const { error, success } = await this.$store.dispatch(
      'estate/estateMaintainTransfer',
      {
        userId: this.repairPersonId,
        id: this.$route.query.id
      }
    )
    if (success) {
      Toast('转派成功')
      this.$router.push('/estateWorker')
    }
    if (error) {
      Toast(error.msg)
    }
  }
}
